import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';
import { graphql, useFragment } from 'react-relay';

import type {
	SpaceCreationEligibility_space$data,
	SpaceCreationEligibility_space$key,
} from './__generated__/SpaceCreationEligibility_space.graphql.ts';

const SpaceCreationEligibilityContext = createContext<SpaceCreationEligibility_space$data | null>(
	null,
);

// Only the navigation subtree provides this context. Global create and controls for another
// space continue using their package-owned queries.
export const SpaceCreationEligibilityProvider = ({
	spaceFragmentRef,
	children,
}: {
	spaceFragmentRef: SpaceCreationEligibility_space$key | null;
	children: ReactNode;
}): React.JSX.Element => {
	const space = useFragment(
		graphql`
			fragment SpaceCreationEligibility_space on Space {
				key
				...FooterCreateButtons_space
				...useSpaceEnabledContentTypes_space
				...ContextualCreateContentButton_space
			}
		`,
		spaceFragmentRef,
	);

	return (
		<SpaceCreationEligibilityContext.Provider value={space ?? null}>
			{children}
		</SpaceCreationEligibilityContext.Provider>
	);
};

export const useSpaceCreationEligibility = (
	spaceKey: string,
): SpaceCreationEligibility_space$data | null => {
	const space = useContext(SpaceCreationEligibilityContext);
	return space?.key === spaceKey ? space : null;
};
